import React from 'react'
import Transition from "components/Transition";
import BlockUi from "react-block-ui";
import clsx from "clsx";

export default function Modal({
                                  fullscreen = false,
                                  open,
                                  content,
                                  loading = null,
                                  contentStyle = null,
                                  onClose = () => {
                                  },
                                  contentClasses = null
                              }) {
    const fullscreenClasses = "fixed bottom-0 inset-x-0 h-screen sm:inset-0 p-0 flex items-center justify-center z-1100";
    const classes = "fixed bottom-0 inset-x-0 px-2 sm:px-4 pb-6 sm:inset-0 p-0 flex items-center justify-center z-1100";
    return (
        <Transition show={open}>
            <div
                className={fullscreen ? fullscreenClasses : classes}
                style={fullscreen ? {
                    height: 'calc(100% - 65px)'
                } : undefined}>


                <Transition
                    show={open}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                    appear={true}
                >
                    <div className="fixed inset-0 transition-opacity">
                        <div className="absolute inset-0 bg-gray-500 opacity-75 z-100" onClick={onClose}/>
                    </div>
                </Transition>


                <Transition
                    show={open}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    appear={true}
                >
                    <BlockUi tag={"div"} blocking={loading}
                             keepInView
                             className={clsx(contentClasses, "modal-container bg-white z-1200 rounded-lg max-h-screen  overflow-auto")}
                             style={contentStyle}>
                        {content}
                    </BlockUi>
                </Transition>

            </div>
        </Transition>
    );
}
